export default __webpack_public_path__ + "static/media/yoshi.ca7f90fb.png";